export const data = [
    {
        id: "0",
        question: "Define 'Constrained' in the context of CAD:",
        answer: "When the location of an object is defined in a 3d plane; unable to move.",
        variants: [`Tied down and secure.`, `When the location of an object is defined in a 3d plane; unable to move.`, `When robot parts do not fall apart.`, `Parts that are securely fastened to the robot with bolts and rivets.`]
    },
    {
        id: "1",
        question: "What tool is used to set the distance between two sketch elements?",
        answer: "Dimension tool",
        variants: [`Circle tool`, `Measure tool`, `Line tool`, `Dimension tool`]
    },
    {
        id: "2",
        question: "What tool is used to show that the end of a line segment is touching another line segment?",
        answer: "",
        variants: [`Vertical tool`, `Tangent tool`, `Concentric tool`, `Incident/Coincident tool`]
    },
    {
        id: "3",
        question: "What tool is used to show that a point is directly below another point?",
        answer: "Vertical tool",
        variants: [`Vertical tool`, `Tangent tool`, `Concentric tool`, `Incident/Coincident tool`]
    },
    {
        id: "4",
        question: "What are the benefits of constraints?",
        answer: "Prevents your sketch from moving around freely.",
        variants: [`Onshape runs faster because it doesn't have to locate the sketch elements.`, `Prevents your sketch from moving around freely.`, `Enables the user to design faster`, `Allows the user to click and drag objects to move them around.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },